import * as types from '../mutation-types'

const state = {
  // Lendo os produtos selecionados de string para JSON de localStorage
  main: []
}

const mutations = {
  [types.ATUALIZAR_PIZZA_ATIVA] (state, pizza) {
    /**
       * Atualiza O produto selecionado e salva como string em localStorage
       */
     state.main = pizza;
    //  localStorage.setItem('produtoAtivo', JSON.stringify(produto));
  },
  [types.REMOVER_PIZZA_ATIVA] (state) {
    /**
       * Limpa O produto selecionados
       */
     state.main = [];
    //  localStorage.removeItem('produtoAtivo');
  },

}

export default {
  state,
  mutations
}

